// extracted by mini-css-extract-plugin
module.exports = {"messages":"styles_messages__1Yk40","messageOrigin":"styles_messageOrigin__AR_Y_","messageSender":"styles_messageSender__1VqMK"};